(ns frontend.view.modals.confirmation.view
  (:require
   [common.localization :as loc]
   [potpuri.core :refer [fn-> fn->>]]
   [frontend.view.modals.confirmation.events :as events]
   [ui.components.modal.view :as modal]
   [ui.components.input.checkbox :as checkbox]
   [ui.color :as c]))

(defonce modal-key :confirmation-modal)

(defn view
  [{:keys [shown? close-modal! props state class-name topmost?]}]
  (events/reset-state! state)
  (fn [{:keys [shown? close-modal! props state class-name topmost?]}]
    (let [{:keys [body title checkbox-text body-class
                  cancel-icon cancel-text
                  confirm-color confirm-icon confirm-text
                  checkbox-class
                  confirms ;; <- extra confirmations
                  skip-checkbox? hide-cancel? on-confirm on-cancel]
           ;; defaults:
           :or   {checkbox-text  (loc/tr :i-understand-theres-no-undo-for-this)
                  title          (loc/tr :attention)
                  body-class     "text-left"
                  checkbox-class "justify-content-start"
                  cancel-text    (loc/tr :cancel)
                  confirm-color  ::c/danger
                  confirm-text   (loc/tr :delete)}}
          props
          confirms-lookup (into {} confirms)
          confirm-kws (map first confirms)
          extras-confirmed? (->> confirm-kws
                                 (map (fn->> (get @state))))
          confirmed? (:confirmed? @state)
          all-confirmed? (->> extras-confirmed?
                              (concat [confirmed?])
                              (every? true?))]
      [modal/view
       {:visible?      (and shown? topmost?)
        :hide!         close-modal!
        :backdrop      "static"
        :color         confirm-color
        :close-button? true}
       title
       [:<>
        [:div
         {:class "pb-4 text-bold"}
         body]
        (doall
         (for [extra confirm-kws
               :let [text (get confirms-lookup extra)
                     confirmed? (get @state extra)]]
           ^{:key (str "extra-confirm-" extra)}
           [:div
            [:div
             [:div
              [:label
               {:class-name "inline-flex flex gap-2 items-center cursor-pointer"}
               [checkbox/view
                {:value     confirmed?
                 :style-variant :tw2
                 :on-change  #(events/toggle-extra! state
                                                    extra
                                                    %)}]
               [:span text]]]]]))

        (when-not skip-checkbox?
          [:div
           {:class "py-3"}
           [:div
            [:label
             {:class-name "inline-flex gap-2 items-center cursor-pointer"}
             [checkbox/view
              {:value     confirmed?
               :on-change  #(events/toggle-confirmed! state
                                                      %)}]
             [:span checkbox-text]]]])]
       [:<>
        (when-not hide-cancel?
          [modal/left-single-button-hollow
           ::c/secondary
           false
           (fn [_]
             (when on-cancel
               (on-cancel))
             (close-modal!))
           (or (:cancel-text props) (loc/tr :cancel))])
        [modal/right-single-button
         confirm-color
         (and (not skip-checkbox?)
              (not all-confirmed?))
         (fn [_]
           (on-confirm)
           (close-modal!))
         confirm-text
         nil]]])))
